<script setup lang="ts">
import Pencil from '@primeicons/vue/pencil';
import Card from 'primevue/card';
import { shipmentDetailCardPt } from '@/components/shipment/detail/shipment-detail-card-pt';

defineProps<{
  notes: string | null | undefined;
}>();

const cardPt = shipmentDetailCardPt;
</script>

<template>
  <Card :pt="cardPt">
    <template #content>
      <div class="mb-3 flex items-center gap-2">
        <Pencil class="text-neutral-400" aria-hidden="true" />
        <h3 class="text-sm font-semibold text-neutral-900">Notes</h3>
      </div>

      <p class="whitespace-pre-wrap text-sm text-neutral-600">
        {{ notes?.trim() || '—' }}
      </p>
    </template>
  </Card>
</template>
